import React, { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Above-fold — loaded eagerly
import Navbar from "./components/landing/Navbar";
import Hero from "./components/landing/Hero";
import About from "./components/landing/About";
import Services from "./components/landing/Services";

// Below-fold — lazy loaded (split the JS bundle)
const WhyChooseUs   = lazy(() => import("./components/landing/WhyChooseUs"));
const EquipmentTypes = lazy(() => import("./components/landing/EquipmentTypes"));
const CtaBanner      = lazy(() => import("./components/landing/CtaBanner"));
const ContactSection = lazy(() => import("./components/landing/ContactSection"));
const Footer         = lazy(() => import("./components/landing/Footer"));
const WhatsAppButton = lazy(() => import("./components/landing/WhatsAppButton"));

// Minimal placeholder that reserves space while the section loads.
// `bg` must match the lazy section's own background, otherwise a white
// placeholder flashes before a dark section paints in (visible as flicker
// while scrolling on mobile).
const Placeholder = ({ h = "400px", bg = "bg-white" }) => (
  <div style={{ minHeight: h }} className={bg} />
);

const Landing = () => (
  <main className="bg-white text-jr-oxford">
    <Navbar />
    <Hero />
    <About />
    <Services />
    <Suspense fallback={<Placeholder h="500px" bg="bg-white" />}>
      <EquipmentTypes />
    </Suspense>
    <Suspense fallback={<Placeholder h="600px" bg="bg-jr-oxford" />}>
      <WhyChooseUs />
    </Suspense>
    <Suspense fallback={<Placeholder h="300px" bg="bg-jr-yale" />}>
      <CtaBanner />
    </Suspense>
    <Suspense fallback={<Placeholder h="600px" bg="bg-jr-gray-bg" />}>
      <ContactSection />
    </Suspense>
    <Suspense fallback={<Placeholder h="300px" bg="bg-jr-oxford" />}>
      <Footer />
    </Suspense>
    <Suspense fallback={null}>
      <WhatsAppButton />
    </Suspense>
    <Toaster
      position="top-right"
      toastOptions={{
        style: {
          fontFamily: "Inter, system-ui, sans-serif",
          borderRadius: "12px",
          border: "1px solid rgba(4, 37, 72, 0.08)",
          boxShadow: "0 10px 40px rgba(4, 37, 72, 0.12)",
        },
        classNames: {
          toast: "!bg-white !text-jr-oxford",
          title: "!text-jr-oxford !font-semibold",
          description: "!text-jr-gray-text",
          success: "!border-l-4 !border-l-jr-cyan",
          error: "!border-l-4 !border-l-jr-yale",
          icon: "!text-jr-cyan",
        },
      }}
    />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
